import ShortUniqueId from "short-unique-id";
import { AnimationLawsEnum } from "../constants/corpus";

const uid = new ShortUniqueId();

export const CHENILLARD_DEFAULT_NB_LED = 0;
export const CHENILLARD_DEFAULT_POSITION = 0;

export const getChenillardLastIndex = (startIndex: number, nbLed?: number) => {
  return startIndex + (nbLed ?? CHENILLARD_DEFAULT_NB_LED);
};

export const getExtraKeys = (pattern: PatternType) => {
  switch (pattern) {
    case "CROISILLON":
      return {
        croisillon: {
          nbLed: 2,
          isVertical: true,
          isHorizontal: true,
        },
      };
    case "DASH":
      return {
        dash: { spaceNbLed: 1, dashNbLed: 1 },
      };
    case "CHENILLARD":
      return {
        chenillard: {
          referenceLed: {
            position: CHENILLARD_DEFAULT_POSITION,
            angle: 0,
          },
          length: {
            nbLed: CHENILLARD_DEFAULT_NB_LED,
            angle: 0, // TODO
          },
          direction: {
            clockwise: true,
            anticlockwise: false,
          },
          propagationType: "DIVERGENT",
        },
      };
    default:
      return {};
  }
};

export const generateCorpusSentence = (pattern: PatternType): CorpusSentenceType =>
  ({
    intensity: 100,
    color: {
      r: 255,
      g: 0,
      b: 0,
    },
    onDurationMs: 1000,
    offDurationMs: 1000,
    nbRepetition: 0,
    pattern,
    id: uid.randomUUID(),
    isGeolocalisable: false,
    animationLaw: AnimationLawsEnum.DIRECTION,
    ...getExtraKeys(pattern),
  }) as CorpusSentenceType;

export const convertSentenceColorToRbgColor = (color: SentenceColor) => `rgb(${color.r}, ${color.g}, ${color.b})`;
